import DataTable from "react-data-table-component"
import DataTableExtensions from 'react-data-table-component-extensions'
import "react-data-table-component-extensions/dist/index.css"
import { useTranslation } from "react-i18next"

const customStyles = {
    headRow: {
        style: {
            background: 'transparent',
            borderBottom: '1px solid var(--neutral-100)',
            minHeight: '40px',
            padding: '0 8px',
        },
    },
    headCells: {
        style: {
            fontSize: '13px',
            fontWeight: 600,
            color: 'var(--neutral-400)',
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
            paddingLeft: '6px',
            paddingRight: '6px',
        },
    },
    rows: {
        style: {
            minHeight: '48px',
            borderBottom: '1px solid var(--neutral-100)',
            fontSize: '14px',
            color: 'var(--neutral-700)',
            padding: '0 8px',
            cursor: 'pointer',
            transition: 'background 0.15s ease',
        },
        highlightOnHoverStyle: {
            background: 'var(--neutral-50)',
        },
    },
    cells: {
        style: {
            paddingLeft: '6px',
            paddingRight: '6px',
        },
    },
    pagination: {
        style: {
            borderTop: '1px solid var(--neutral-100)',
            marginTop: '8px',
            paddingTop: '12px',
            fontSize: '13px',
            color: 'var(--neutral-500)',
            minHeight: '56px',
        },
    },
    noData: {
        style: {
            padding: '48px 0',
            color: 'var(--neutral-400)',
            fontSize: '15px',
        },
    },
    expanderRow: {
        style: {
            borderBottom: '1px solid var(--neutral-100)',
        },
    },
}

export const CustomDataTable = (props) => {
    const { t } = useTranslation()

    const {columns, data, pagination = true, exportable = true, printable = true, expandedData, conditionalRowStyles = null, filter = false, paginationServer, paginationTotalRows, paginationDefaultPage, paginationPerPage, onChangePage, onChangeRowsPerPage, onSort, progressPending, progressComponent, onRowClicked} = props

    const datatable = (
        <DataTable
            columns={columns}
            data={data}
            customStyles={customStyles}
            noDataComponent={
                <div className="empty-state" style={{ padding: '48px 0' }}>
                    <div className="empty-state-text">{t('datatables.sinresultados')}</div>
                </div>
            }
            labelRowsPerPage={t('datatables.elementosporpagina')}
            defaultSortField="id"
            defaultSortFieldId="id"
            defaultSortAsc={false}
            expandableRows={!!expandedData}
            expandableRowsComponent={expandedData ? expandedData : undefined}
            pagination={!!pagination}
            paginationRowsPerPageOptions={[10, 25, 50, 100, 500]}
            paginationPerPage={paginationPerPage || 25}
            paginationServer={paginationServer}
            paginationTotalRows={paginationTotalRows}
            paginationDefaultPage={paginationDefaultPage}
            onChangePage={onChangePage}
            onChangeRowsPerPage={onChangeRowsPerPage}
            onSort={onSort}
            progressPending={progressPending}
            progressComponent={progressComponent}
            paginationComponentOptions={{
                rowsPerPageText: t('datatables.elementosporpagina'),
                rangeSeparatorText: t('datatables.de'),
                noRowsPerPage: false,
                selectAllRowsItem: true,
                selectAllRowsItemText: t('datatables.todos')
            }}
            conditionalRowStyles={conditionalRowStyles || []}
            pointerOnHover={true}
            highlightOnHover={true}
            onRowClicked={onRowClicked}
        />
    )

    if (paginationServer) {
        return datatable
    }

    const tableData = {
        columns,
        data,
        exportHeaders: true,
        print: printable,
        export: exportable,
        filterPlaceholder: t('datatables.buscar'),
        filterDigit: 3,
        filter
    }

    return <DataTableExtensions {...tableData}>{datatable}</DataTableExtensions>
}